import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import ReleaseReport from '../components/report/ReleaseReport';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ meetingRelease, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <ReleaseReport
          intl={intl}
          dispatch={dispatch}
          meetingRelease={meetingRelease}
          loading={loading}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/ReleaseReport.js